import { timeout, delay } from '@ynap/promise-utils'
import { ResponseError, Person } from '@ynap/api-utils'
import { raygun } from '@ynap/clientside-monitoring'
import { push } from 'connected-react-router'
import {
    FETCH_LOYALTY_CONSENT_REQUEST,
    FETCH_LOYALTY_CONSENT_SUCCESS,
    FETCH_LOYALTY_CONSENT_ERROR,
} from '../constants/ActionTypes'

const reportToRaygun = (message, { requestBody, error }) =>
    raygun.helpers.agent('send', {
        error: new Error(message),
        tags: ['user-attribute', 'loyalty-consent', 'fetch-user-context-attribute'],
        customData: {
            requestBody,
            errorString: error.toString(),
        },
    })

export function fetchLoyaltyConsentRequest() {
    return {
        type: FETCH_LOYALTY_CONSENT_REQUEST,
    }
}

export function fetchLoyaltyConsentSuccess(preferences) {
    return {
        type: FETCH_LOYALTY_CONSENT_SUCCESS,
        body: preferences,
    }
}

export function fetchLoyaltyConsentError(error) {
    return {
        type: FETCH_LOYALTY_CONSENT_ERROR,
        body: error,
    }
}

export default function fetchLoyaltyConsent() {
    return (dispatch, getState) => {
        const { locale, config, router, uberToken } = getState()
        const { location = {} } = router
        const { country } = locale
        const { pathname } = location
        const { clientRequest } = config.head || config
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce
        const { brandId } = config.watsonService || config.global.application

        if (!uberToken) {
            return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`))
        }

        dispatch(fetchLoyaltyConsentRequest())

        const request = Person.getUserContextAttributes({
            baseUrl,
            brandId,
            country,
            uberToken,
            clientId,
            clientSecret,
            attribute: 'maLoyaltyConsent',
        })

        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((res) => {
                const { ok, status } = res
                if (ok) {
                    return res.json().then((json) => dispatch(fetchLoyaltyConsentSuccess(json)))
                } else if (status === 401) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`))
                } else if (status === 404) {
                    return res.json().then((json) => dispatch(fetchLoyaltyConsentError(json)))
                }

                throw new ResponseError(res)
            })
            .catch((error) => {
                dispatch(fetchLoyaltyConsentError(error))
                reportToRaygun(
                    `Unsucessful response when hitting ${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/person/@self/contextattributes/maLoyaltyConsent`,
                    {
                        error,
                    }
                )
                throw error
            })
    }
}
